import { z } from 'zod'

export const framingSchema = z.object({
  x: z.number().optional(),
  y: z.number().optional(),
})

export const mediaEntrySchema = z.object({
  key: z.string(),
  url: z.string(),
  bytes: z.number().int().nonnegative(),
  type: z.enum(['video', 'image']),
  tier: z.enum(['critical', 'deferred', 'lazy']),
  optimized: z.boolean(),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
  full: z.string().optional(),
  framing: framingSchema.optional(),
})

export const accountSchema = z.object({
  role: z.string(),
  name: z.string(),
  bank: z.string(),
  number: z.string(),
})

export const contactSchema = z.object({
  groom: z.object({ tel: z.string() }).optional(),
  bride: z.object({ tel: z.string() }).optional(),
  accounts: z
    .object({
      groom: z.array(accountSchema).optional(),
      bride: z.array(accountSchema).optional(),
    })
    .optional(),
})

export const bootstrapSchema = z.object({
  media: z.array(mediaEntrySchema),
  contact: contactSchema,
  snapUploadOpenAt: z.string().nullable(),
})

export const snapUploadResultSchema = z.object({
  accepted: z.array(z.object({ original: z.string(), bytes: z.number().int().nonnegative() })),
  rejected: z.array(z.object({ original: z.string(), reason: z.string() })),
})

export type Framing = z.infer<typeof framingSchema>
export type MediaEntry = z.infer<typeof mediaEntrySchema>
export type Account = z.infer<typeof accountSchema>
export type Contact = z.infer<typeof contactSchema>
export type Bootstrap = z.infer<typeof bootstrapSchema>
export type SnapUploadResult = z.infer<typeof snapUploadResultSchema>
